import React from "react";
import DateTimeCell from "license/LicenseList/cells/DateTimeCell";
import DetailsCell from "license/LicenseList/cells/DetailsCell";
import StatusCell from "license/LicenseList/cells/StatusCell";
import ProductsCell from "license/LicenseList/cells/ProductsCell";
import StateCell from "license/LicenseList/cells/StateCell";
import { LICENSE_STATUS } from "license/constants";
const customColumnRenderers = {
  attributes: {
    status: {
      renderCell: (status) => /* @__PURE__ */ React.createElement(StatusCell, { status })
    },
    products: {
      renderCell: (products, license) => /* @__PURE__ */ React.createElement(ProductsCell, { products, licenseType: license.license_type })
    },
    start_date: {
      renderCell: (start_date) => /* @__PURE__ */ React.createElement(DateTimeCell, { dateTime: start_date })
    },
    end_date: {
      renderCell: (end_date) => /* @__PURE__ */ React.createElement(DateTimeCell, { dateTime: end_date })
    },
    details: {
      renderCell: (details) => /* @__PURE__ */ React.createElement(DetailsCell, { details })
    },
    violations: {
      renderCell: (violations, license) => {
        var _a;
        if (license.status === LICENSE_STATUS.inactive || license.status === LICENSE_STATUS.queued) {
          return /* @__PURE__ */ React.createElement(React.Fragment, null, "N/A");
        }
        return /* @__PURE__ */ React.createElement(StateCell, { violations, version: (_a = license.details) == null ? void 0 : _a.version });
      }
    }
  }
};
export default customColumnRenderers;
